import { ILayerTreeNodeLeaf } from '../models/layer-tree-node-leaf';

export class NodeActivationChangedEventArgs {
	public node: ILayerTreeNodeLeaf;
	public newState: boolean;

	constructor(node: ILayerTreeNodeLeaf, newState: boolean) {
		this.node = node;
		this.newState = newState;
	}
}



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/menu-items/layers-manager/event-args/node-activation-changed-event-args.ts